/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_ReadyInputs */

const en_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready`)
};

const de_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereit`)
};

const fr_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prêt`)
};

const es_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo`)
};

const it_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pronto`)
};

const nl_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaar`)
};

const pl_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gotowe`)
};

const fi_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Valmis`)
};

const da_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar`)
};

const sv_common_ready = /** @type {(inputs: Common_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar`)
};

/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Common_ReadyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const common_ready = /** @type {((inputs?: Common_ReadyInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_ReadyInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_common_ready(inputs)
	if (locale === "fr") return fr_common_ready(inputs)
	if (locale === "es") return es_common_ready(inputs)
	if (locale === "it") return it_common_ready(inputs)
	if (locale === "nl") return nl_common_ready(inputs)
	if (locale === "pl") return pl_common_ready(inputs)
	if (locale === "fi") return fi_common_ready(inputs)
	if (locale === "da") return da_common_ready(inputs)
	if (locale === "sv") return sv_common_ready(inputs)
	return en_common_ready(inputs)
});